module.exports = __webpack_public_path__ + "img/ill_8.18e98db3.png";